export default __webpack_public_path__ + "static/media/whats-are-nft.aeafbcdd.png";